<div class="rn-types-container align-items-center d-flex">
    <ng-container *ngFor="let t of releaseNotesTypes">
        <span (click)="readyOnly ? false : toggleStatus(t)" [ngClass]="{'toggler': !readyOnly, 'active': t.status}" class="badge badge-release-note-type badge-{{t.type}} badge-{{size}} mr-2">{{ t.type | translate }}</span>
    </ng-container>
</div>
